import { html } from 'lit';
import country_codes from '@yourbarmate/country-codes';
import { BaseElement } from '../base.js';

class SharedCountrySelector extends BaseElement {
  static properties = {
    selected: { attribute: true }
  };

  constructor() {
    super();
    this.selected = 'CH';
  }

  render() {
    return html`
      <select class="form-select" name="country">
        ${country_codes.map(
          ({ code, en }) => html`
            <option value="${code}" ?selected=${code === this.selected}>
              ${en}
            </option>
          `
        )}
      </select>
    `;
  }
}

customElements.define('shared-country-selector', SharedCountrySelector);
